import React from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'
import ms from 'pretty-ms'
import RefreshIcon from 'react-icons/lib/io/refresh'
import MissingIcon from 'react-icons/lib/io/close'
import TimeIcon from 'react-icons/lib/io/android-time'

import { checkStatus, resetStatuses } from 'webmango-core/effects/status'

import titleize from '../utils/titleize'
import { needsSync, isReady } from '../selectors'
import * as Dropdown from './DropdownMenu'

import './ServerStatus.css'

export default connect((state) => {
  return { isReady: isReady(state) }
})(({ isReady, ...props }) => {
  if (!isReady) return <div className='ServerStatus' />
  return <ServerStatus {...props} />
})

export const ServerStatus = connect((state, props) => {
  const { status, sync } = state
  const initialised = Object.entries(status).reduce((o, [key, status]) => Object.assign(o, {
    [key]: !!Object.keys(status).length
  }), {})

  const problems = Object.entries(status).map(([ key, value ]) => {
    if (value.ok) return
    return key
  }).filter(Boolean)
  const ok = !problems.length

  return {
    ok,
    problems,
    isSyncing: !!sync.active.size,
    needsSync: needsSync(state),
    allInitialised: Object.values(initialised).every(s => s)
  }
})(class ServerStatusMessage extends React.PureComponent {
  componentDidMount () {
    checkStatus()
  }

  render () {
    const { allInitialised, isSyncing, needsSync, ok, problems } = this.props
    return (
      <div className='ServerStatus'>
        <Dropdown.Menu name='ServerStatusDropdown' keepClick>
          <ServerStatusDropdownContent />
        </Dropdown.Menu>
        <Trigger name='ServerStatusDropdown'>
          {(!!allInitialised && !ok) ? (
            <span className='triggerMessage notOk'>
              Connection Problem{problems.length > 1 ? 's' : '' }
            </span>
          ) : (
            <span className='triggerMessage' />
          )}
          <StatusIcon ok={ok} isUnknown={!allInitialised} isSyncing={isSyncing} needsSync={needsSync} />
        </Trigger>
      </div>
    )
  }
})

const ServerStatusDropdownContent = connect((state, props) => {
  const { isLoadingServerStatus, status } = state
  const initialised = Object.entries(status).reduce((o, [key, status]) => Object.assign(o, {
    [key]: !!Object.keys(status).length
  }), {})

  const problems = Object.entries(status).map(([ key, value ]) => {
    if (value.ok) return
    return key
  }).filter(Boolean)

  const ok = !problems.length

  return {
    ok,
    status,
    isLoading: isLoadingServerStatus,
    initialised,
    allInitialised: Object.values(initialised).every(s => s)
  }
})(class ServerStatusDropdownContent extends React.Component {
  state = {
    lastChecked: Date.now()
  }

  componentDidMount () {
    this.checkStatus()
  }

  checkStatus () {
    this.setState({ lastChecked: Date.now() })
    checkStatus()
  }

  onClick = () => {
    resetStatuses()
    checkStatus()
  }

  componentDidUpdate () {
    const interval = this.props.allInitialised && this.props.ok ? 1000 * 2 : 1000 * 2
    if (this.state.lastChecked - Date.now() > interval) {
      this.checkStatus()
    }
  }

  render () {
    const { status, initialised, isLoading } = this.props
    return (
      <React.Fragment>
        <div className='ServerStatusHeader'>
          <h3>Service Status</h3>
          <div
            className={cx('RefreshButton', {disabled: isLoading['checkStatus']})}
            onClick={this.onClick}
          >
            <RefreshIcon
              className='Icon'
            />
          </div>
        </div>
        <div className='ServerStatuses'>
          {Object.entries(status).map(([key, status]) => {
            const isUnknown = !initialised[key]
            return (
              <React.Fragment key={key}>
                <div title={status.message}>
                  <StatusIcon
                    ok={status.ok}
                    isUnknown={isUnknown}
                    isLoading={isLoading[key]}
                  />
                </div>
                <div title={status.message}>{titleize(key)}</div>
                <div title={status.message} className={cx('StatusTime', { isUnknown, notOk: !status.ok })}>
                  {isUnknown ? <TimeIcon className='Icon' /> : (
                    status.time === null ? <MissingIcon className='Icon' title={`${titleize(key)} is down.`} /> : (
                      status.time != null ? ms(status.time) : (
                        ''
                      )
                    )
                  )}
                </div>
              </React.Fragment>
            )
          })}
        </div>
      </React.Fragment>
    )
  }
})

class StatusIcon extends React.Component {
  state = {
    ok: false
  }

  static getDerivedStateFromProps (props, state) {
    return {
      ok: props.ok || state.ok
    }
  }

  render () {
    const { ok = true, isLoading = false, isSyncing = false, isUnknown = false, needsSync = false } = this.props
    return (
      <div
        className={cx('StatusIcon', {
          isSyncing,
          isLoading,
          needsSync,
          isUnknown,
          notOk: !ok,
          ok
        })}
      />
    )
  }
}

const Trigger = Dropdown.API(({ dropdownOpen, children }) => (
  <span className='ServerStatusTrigger' onClick={Dropdown.onTriggerClick(dropdownOpen)} children={children} />
))



// WEBPACK FOOTER //
// ./src/components/ServerStatus.js